module.exports = __webpack_public_path__ + "img/banner1.528889a6.jpg";